import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import type {
  CompaniesFilterParamsApi,
  CompanyApi,
} from '@/modules/companies/types';

import { companiesQueryKeys } from './queryKeys';

interface UseCompaniesQueryOptions extends Omit<
  UseQueryOptions<CompanyApi[] | undefined, unknown>,
  'queryKey' | 'queryFn'
> {
  filters?: CompaniesFilterParamsApi;
}

export const useCompaniesQuery = ({
  filters,
  ...options
}: UseCompaniesQueryOptions = {}) => {
  return useQuery({
    queryKey: companiesQueryKeys.list(filters),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.companies, {
        params: { query: filters },
      });
      return data;
    },
    ...options,
  });
};
